import { createFileRoute } from '@tanstack/react-router'
import { ConnectDeskScreen } from '../features/auth/connect-desk'
import { safeReturnTo } from '../lib/safeUrl'

interface ConnectDeskSearch {
  return_to?: string
  error?: string
}

/** Owned by web-shell (features/auth): the Connect Desk screen, reachable from every blocked send box. */
export const Route = createFileRoute('/connect-desk')({
  validateSearch: (s: Record<string, unknown>): ConnectDeskSearch => ({
    return_to: typeof s.return_to === 'string' ? s.return_to : undefined,
    error: typeof s.error === 'string' ? s.error.slice(0, 64) : undefined,
  }),
  component: ConnectDeskRoute,
})

function ConnectDeskRoute() {
  const search = Route.useSearch()
  return <ConnectDeskScreen returnTo={safeReturnTo(search.return_to)} error={search.error} />
}
